// @flow

export {default as getStackTrace} from './getStackTrace';
